import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=1fed3a1e&scoped=true"
import script from "./import-file.ts?vue&type=script&lang=ts&external"
export * from "./import-file.ts?vue&type=script&lang=ts&external"
import style0 from "./import-file.scoped.scss?vue&type=style&index=0&id=1fed3a1e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed3a1e",
  null
  
)

export default component.exports